export const commitmentTranslations = {
  es: {
    personalInformation: "Información personal",
    commitmentFormSubTitle: "Ministerio de Evangelización",
    registrationForm: "Formulario de inscripción",
    none: "Ninguno",
    noneAtTheMoment: "Ninguno por el momento",
    firstNameIsRequired: "El nombre es requerido",
    lastNameIsRequired: "El apellido es requerido",
    birthDateIsRequired: "La fecha de nacimiento es requerida",
    convertionDateIsRequired: "La fecha de conversión es requerida",
    lastGroupNameIsRequired: "El último grupo es requerido",
    ageIsRequired: "La edad es requerida",
    childrensCountIsRequired: "La cantidad de hijos es requerida",
    phoneIsRequired: "El teléfono es requerido",
    fieldIsRequired: "Este campo es requerido",
    invalidEmail: "El email es inválido",
    commitmentMenuInscription: "Ficha",
    firstName: "Nombres",
    lastName: "Apellidos",
    phone: "Teléfono",
    gender: "Sexo",
    email: "Correo electrónico",
    birthDate: "Fecha de nacimiento",
    maritalStatus: "Estado civil",
    childrenCount: "Cantidad de hijos",
    conversionDate: "Fecha de conversión",
    yearsOfService: "Años de servicio activo",
    yearsOfConvertion: "Años de conversión",
    lastGroupName: "¿Grupo en el que te comprometiste el año pasado?",
    minister: "Ministerio",
    ministry: "Ministro o pastor",
    armOfMinistry: "Brazo en el Ministerio (si aplica)",
    tribe: "Nombre o Número de Barca / Tribu (si aplica)",
    fold: "Nombre del último Redil cursado (si no asistes, coloca: “No asisto”)",
    attendance: "Asistencia",
    commitmentAttendance: "Asistencia al retiro de compromiso",
    willAttendYes: "Sí, asistiré",
    willAttendNo: "No, no asistiré",
    submitRegistration: "Enviar inscripción",
    month: "Mes",
    day: "Día",
    year: "Año",
    age: "Edad",
    years: "Años",
    group: "Grupo",
    leaderAwareYes: "Sí, el líder está enterado",
    leaderAwareNo: "No, el líder no está enterado",
    comments: "Comentarios",
    community: "Comunidad",
    commitmentFilterPlaceholder: "Filtrar por compromiso",
    spouseName: "Nombre del cónyuge",
    isSpouseServer: "¿Su cónyuge será servidor(a) este año?",
    registrationSuccess: "Gloria a Dios!",
    jesusIsWaiting: "Jesús te espera",
    seeYouAtRetreat: "¡Nos vemos en el retiro!",
    registerAnother: "Registrar otro servidor",
    registeredByGroup: "Inscritos por grupo",
    ministryIsRequired: "El Ministro o pastor es requerido",
    foldIsRequired: "El Redil es requerido",
    serverPhoneAlreadyExists: "Ya existe un servidor con este teléfono",
    searchServer: "Buscar servidor",
    serverDetails: "Detalles del servidor",
    server: "Servidor",
    noServer: "Pueblo",
    willAttend: "Asistirá",
    guest: "Invitado",
    noServersRegistered: "No hay servidores registrados",
    leaderIsAware: "El líder está enterado",
    registered: "Inscritos",
    viewCards: "Ver tarjetas",
    viewTable: "Ver tabla",
    serversByGroup: "Servidores por grupo",
    serversByAge: "Servidores por edad",
    viewIndicators: "Ver totales",
    summary: "Totales",
    commitmentMenuServers: "Servidores",
    commitmentMenuPayments: "Pagos",
    commitmentMenuAttendance: "Asistencia",
    addPayment: "Agregar pago",
    convertionYears: "Años de conversión",
    attendancePaymentPendingTitle: "Pago pendiente",
    guestForm: "Invitado",
    invitedFor: "Nombre del servidor que lo invita",
    groupInvitedFor: "Grupo del servidor que lo invita",
    commitmentMenuGuests: "Invitados",
    exportCsv: "Exportar CSV",
    exportPdf: "Exportar PDF",
    exportXlsx: "Exportar XLSX",
    export: "Exportar",
    commitmentMenuInscriptionNormal: "Ficha para servidor",
    setAttendance: "Marcar asistencia",
    servers: "Servidores",
    guests: "Invitados"
  },
  en: {
    personalInformation: "Personal Information",
    registrationForm: "Registration Form",
    commitmentFormSubTitle: "Ministry of Evangelization",
    none: "None",
    noneAtTheMoment: "None at the moment",
    firstNameIsRequired: "First name is required",
    lastNameIsRequired: "Last name is required",
    birthDateIsRequired: "Birth date is required",
    convertionDateIsRequired: "Conversion date is required",
    ageIsRequired: "Age is required",
    childrensCountIsRequired: "Children count is required",
    lastGroupNameIsRequired: "Last group name is required",
    phoneIsRequired: "Phone is required",
    commitmentMenuInscription: "Card",
    fieldIsRequired: "This field is required",
    invalidEmail: "Invalid email",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone",
    email: "Email",
    gender: "Gender",
    birthDate: "Birth date",
    maritalStatus: "Marital status",
    childrenCount: "Children count",
    conversionDate: "Conversion date",
    yearsOfService: "Years of active service",
    yearsOfConvertion: "Years of conversion",
    lastGroupName: "Group in which you committed last year?",
    minister: "Ministry",
    ministry: "Minister or pastor (if applicable)",
    armOfMinistry: "Arm of Ministry (if applicable)",
    tribe: "Name or Number of Boat / Tribe (if applicable)",
    fold: "Name of the Fold you attend: (if you do not attend, put: “I do not attend”)",
    attendance: "Attendance",
    commitmentAttendance: "Commitment retreat attendance",
    willAttendYes: "Yes, I will attend",
    willAttendNo: "No, I will not attend",
    submitRegistration: "Submit registration",
    month: "Month",
    day: "Day",
    year: "Year",
    age: "Age",
    years: "Years",
    group: "Group",
    leaderAwareYes: "Yes, the leader is aware",
    leaderAwareNo: "No, the leader is not aware",
    comments: "Comments",
    community: "Community",
    commitmentFilterPlaceholder: "Filter by commitment",
    spouseName: "Spouse name",
    isSpouseServer: "Is spouse of server?",
    registrationSuccess: "Registration successful!",
    jesusIsWaiting: "Jesus is waiting for you",
    seeYouAtRetreat: "See you at the retreat!",
    registerAnother: "Register another server",
    registeredByGroup: "Registered by group",
    ministryIsRequired: "Minister or pastor is required",
    foldIsRequired: "Fold is required",
    serverPhoneAlreadyExists: "Server phone already exists",
    searchServer: "Search server",
    serverDetails: "Server details",
    server: "Server",
    noServer: "No server",
    willAttend: "Will attend",
    guest: "Guest",
    noServersRegistered: "No servers registered",
    leaderIsAware: "Leader is aware",
    registered: "Registered",
    viewCards: "View cards",
    viewTable: "View table",
    serversByGroup: "Servers by group",
    serversByAge: "Servers by age",
    viewIndicators: "View indicators",
    summary: "Totales",
    commitmentMenuServers: "Servers",
    commitmentMenuPayments: "Payments",
    commitmentMenuAttendance: "Attendance",
    addPayment: "Add payment",
    convertionYears: "Years of conversion",
    attendancePaymentPendingTitle: "Payment pending",
    guestForm: "Guest",
    invitedFor: "Name of the server that invites you",
    groupInvitedFor: "Grupo del servidor que lo invita",
    commitmentMenuGuests: "Guests",
    exportCsv: "Export CSV",
    exportPdf: "Export PDF",
    exportXlsx: "Export XLSX",
    export: "Export",
    commitmentMenuInscriptionNormal: "Form for server",
    setAttendance: "Set attendance",
    servers: "Servers",
    guests: "Guests"
  }
};
